import React from 'react';

import Blackduck from '../../images/blackduck.svg';

export const BlackduckLogo = () => {
  return <img height="18" src={Blackduck} alt="Blackduck logo" />;
};
